export default "__VITE_ASSET__fe63f89c__"